<template>
  <v-container>
    <v-form
      style="max-width: 900px; margin: auto"
      class="pa-2"
      @submit.prevent="login"
      ref="login"
    >
      <v-card>
        <v-sheet color="primary">
          <v-card-title class="white--text">{{
            $store.getters.getTenant.app
          }}</v-card-title>
        </v-sheet>
        <v-row class="mt-6">
          <v-col cols="12" md="6">
            <v-img
              class="logo mb-4"
              contain
              :src="$store.getters.getTenant.logo"
              max-height="300"
              alt="logo"
            />
          </v-col>
          <v-col cols="12" md="6">
            <div class="pa-4 pt-0">
              <v-alert
                class="mt-2"
                v-model="error"
                type="error"
                v-t="'login.error'"
              ></v-alert>

              <v-text-field
                v-model="usuario"
                filled
                :label="$t('login.usuario')"
                name="username"
                type="text"
                dense
                hide-details="auto"
                class="my-4"
                :rules="[rules.req]"
              ></v-text-field>
              <v-text-field
                v-model="pass"
                filled
                :label="$t('login.pass')"
                name="password"
                :type="showPassword ? 'text' : 'password'"
                dense
                hide-details="auto"
                class="my-4"
                :rules="[rules.req]"
              >
                <template v-slot:append>
                  <v-btn @click.stop="showPassword = !showPassword" icon>
                    <v-icon v-if="!showPassword">mdi-eye</v-icon>
                    <v-icon v-else>mdi-eye-off</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
              <v-btn type="submit" block color="primary" :loading="loading">{{
                $t("login.login")
              }}</v-btn>
              <!-- check terminos y condiciones -->
              <v-checkbox v-model="empresa" class="mt-4" :rules="[rules.req]">
                <template v-slot:label>
                  He leído y acepto los 
                  <a
                    v-if="$store.getters.getTenant.politica_privacidad"
                    @click.stop
                    :href="$store.getters.getTenant.politica_privacidad"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    términos y condiciones
                  </a>
                  <span v-else> términos y condiciones </span>
                </template>
              </v-checkbox>

              <!-- <div class="text-center mt-4">
                <v-btn text @click.stop.prevent="forgotDialog = true">
                  No recuerdo mi contraseña
                </v-btn>
              </div> -->
            </div>
          </v-col>
        </v-row>
      </v-card>

      <div class="d-flex flex-column">
        <hr
          class="mt-6 flex-grow-1"
          style="
            background: var(--v-primary-base);
            height: 5px;
            border: none;
            border-radius: 5px;
          "
        />
        <div>
          <v-icon left small>mdi-copyright</v-icon>
          <b>{{ new Date().getFullYear() }}</b>
        </div>
      </div>
    </v-form>

    <v-dialog v-model="recovery_required" max-width="600">
      <v-card>
        <v-card-title class="headline"
          >Cambio de contraseña obligatorio</v-card-title
        >

        <v-card-text>
          <v-form ref="recoveryForm">
            <v-text-field
              v-model="currentpass"
              filled
              label="Contraseña actual"
              type="password"
              dense
              hide-details="auto"
              class="my-4"
            />
            <v-text-field
              v-model="newpass"
              filled
              label="Contraseña nueva"
              type="password"
              dense
              hide-details="auto"
              class="my-4"
              :rules="[rules.password, rules.req]"
            />

            <v-text-field
              filled
              label="Repetir contraseña nueva"
              type="password"
              dense
              hide-details="auto"
              class="my-4"
              :rules="[rules.password, rules.req]"
              v-model="repeatpass"
              @change="checkrepeat"
            />
            <v-alert
              v-if="passError"
              type="error"
              class="my-2"
              v-text="passError"
            />
            <v-text-field
              v-model="telefono"
              filled
              label="Teléfono"
              type="number"
              dense
              class="my-4"
              :rules="[rules.phone, rules.req]"
            />
            <v-alert v-if="alertMessage" :type="alertType" class="my-2">
              {{ alertMessage }}
            </v-alert>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="submitRecovery" :loading="loading">
            {{ $t("recover.send") }}
          </v-btn>
          <v-btn text @click="recovery_required = false">
            {{ $t("common.cancelar") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="tfaDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Verificación en dos pasos</v-card-title>
        <v-card-text>
          <v-alert type="info" dense>
            Ingresa el código que enviamos a tu teléfono.
          </v-alert>
          <v-text-field
            v-model="tfaCode"
            label="Código SMS"
            type="text"
            dense
            hide-details="auto"
            class="my-4"
            :rules="[rules.req]"
          />
          <v-alert v-if="tfaError" type="error" dense>{{ tfaError }}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" :loading="loading" @click="verifyTFA">
            Verificar
          </v-btn>
          <v-btn text @click="tfaDialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <recovery-dialog v-model="forgotDialog" />
  </v-container>
</template>

<script>
import { req, phone, password } from "@/utils/validations";
import axios from "axios";
import RecoveryDialog from "./recovery.vue";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || "http://localhost:8000/api/v1",
});
function getDeviceFingerprint() {
  let clientId = localStorage.getItem("clientId");
  if (!clientId) {
    clientId = crypto.randomUUID();
    localStorage.setItem("clientId", clientId);
  }
  return `web-${navigator.userAgent}-${clientId}`;
}

export default {
  components: {
    RecoveryDialog,
  },
  data() {
    return {
      forgotDialog: false,
      portal: ((
        s = window.location.host.replaceAll(/www./g, "").split(".")[0]
      ) => s && s[0] && s[0].toUpperCase() + s.slice(1))(),
      recovery_required: false,
      usuario: null,
      pass: null,
      error: false,
      empresa: null,
      loading: false,
      modalEmpresa: false,
      newpass: null,
      currentpass: null,
      telefono: null,
      msg: this.$route.query.msg,
      development: process.env.NODE_ENV == "development",
      empresas: [],
      rules: { req, phone, password },
      showPassword: false,
      userRef: null,
      email: null,
      repeatpass: null,
      passError: null,
      tfaDialog: false,
      tfaCode: "",
      tfaToken: "", // challenge_token
      tfaError: null,
      alertMessage: null,
      alertType: "success",
      failedAttempts: 0,
    };
  },
  methods: {
    async verifyTFA() {
      if (!this.tfaCode) {
        this.tfaError = "El código es obligatorio";
        return;
      }

      this.loading = true;
      try {
        const res = await api.post(
          "/tfa/verify",
          {
            userRef: this.userRef,
            challenge_token: this.tfaToken,
            code: this.tfaCode,
          },
          { headers: { "Content-Type": "application/json" } }
        );

        this.loading = false;

        if (res.data.access_token) {
          const token = res.data.access_token;

          // Reiniciar contador de intentos fallidos
          this.failedAttempts = 0;

          // Guardar token en store y localStorage
          this.$store.commit("login", token);
          localStorage.setItem("access_token", token);

          // Registrar dispositivo si no estaba recordado
          const deviceFingerprint = getDeviceFingerprint();
          try {
            await api.post(
              "/tfa/addRememberedDevice",
              { device_id_hash: deviceFingerprint },
              { headers: { Authorization: `Bearer ${token}` } }
            );
          } catch (err) {
            console.warn(
              "No se pudo registrar dispositivo:",
              err.response || err
            );
          }

          // Cerrar diálogo TFA y recargar
          this.tfaDialog = false;
          window.location.reload();
          return;
        }

        this.tfaError = "Error inesperado, por favor intente de nuevo.";
      } catch (err) {
        this.loading = false;

        // Incrementar contador de intentos fallidos
        this.failedAttempts++;

        const msg =
          err.response?.data?.detail ||
          err.response?.data?.error ||
          "Error al verificar el código";
        this.tfaError = msg;

        // Si supera los 3 intentos, solicitar un nuevo código OTP
        if (this.failedAttempts >= 3) {
          this.tfaError =
            "Has superado el número máximo de intentos. Se enviará un nuevo código.";
          this.loading = true;

          try {
            // 🔁 Solicitar nuevo OTP
            const resend = await api.post("/tfa/send_otp_code", {
              userRef: this.userRef,
            });

            // Actualizar challenge_token y limpiar código anterior
            this.tfaToken = resend.data.challenge_token;
            this.tfaCode = "";
            this.failedAttempts = 0; // reiniciar contador

            this.tfaError =
              "Se ha enviado un nuevo código. Por favor, revisa tu teléfono.";
          } catch (resendErr) {
            this.tfaError =
              resendErr.response?.data?.detail ||
              "No se pudo generar un nuevo código. Inténtalo más tarde.";
          } finally {
            this.loading = false;
          }
        }
      }
    },

    submitRecovery() {
      if (!this.$refs.recoveryForm.validate()) return;
      if (!this.checkrepeat()) return;

      this.loading = true;

      const payload = {
        ref: this.userRef,
        old_password: this.currentpass,
        new_password: this.newpass,
        telefono: this.telefono,
      };

      const token =
        localStorage.getItem("access_token") ||
        this.$store.getters["auth/token"];

      api
        .post("/auth/cambio_clave", payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          this.loading = false;
          this.alertMessage =
            res.data.msg || "Contraseña actualizada correctamente";
          this.alertType = "success";

          // Opcional: limpiar campos
          this.currentpass = "";
          this.newpass = "";
          this.repeatpass = "";
        })
        .catch((err) => {
          this.loading = false;
          const msg =
            err.response?.data?.detail || "Error al actualizar la contraseña";

          this.alertMessage = msg;
          this.alertType = "error";
        });
    },
    login() {
      if (!this.$refs["login"].validate()) return;
      this.loading = true;

      this.$store
        .dispatch("login", { user: this.usuario, password: this.pass })
        .then(async (res) => {
          this.loading = false;

          if (res.access_token) {
            localStorage.setItem("access_token", res.access_token);
            this.$router.push(this.$route.query.redirect || "/");
            return;
          }

          if (res.recovery_required) {
            this.recovery_required = true;
            this.userRef = res.ref;
            this.email = res.email;
            return;
          }

          if (res.TFA) {
            this.userRef = res.ref;
            this.tfaToken = res.challenge_token;

            const deviceFingerprint = getDeviceFingerprint();
            try {
              const check = await api.post(
                "/tfa/checkRememberedDevice",
                { device_id_hash: deviceFingerprint },
                { headers: { Authorization: `Bearer ${res.challenge_token}` } }
              );
              if (check.data.exists) {
                const token = check.data.access_token;

                // Guardar token en store y localStorage
                this.$store.commit("login", token);
                localStorage.setItem("access_token", token);

                // Configurar axios con el token para futuras llamadas
                api.defaults.headers.common[
                  "Authorization"
                ] = `Bearer ${token}`;

                // Registrar dispositivo recordado (opcional, ya debería estar registrado)
                const deviceFingerprint = getDeviceFingerprint();
                try {
                  await api.post(
                    "/tfa/addRememberedDevice",
                    { device_id_hash: deviceFingerprint },
                    { headers: { Authorization: `Bearer ${token}` } }
                  );
                } catch (err) {
                  console.warn(
                    "No se pudo registrar dispositivo:",
                    err.response || err
                  );
                }

                // Redirigir y recargar la página
                this.$router.push(this.$route.query.redirect || "/");
                window.location.reload();

                return;
              }
            } catch (err) {
              console.warn(
                "Error al verificar dispositivo recordado:",
                err.response || err
              );
            }

            // Si no está recordado, mostrar diálogo TFA
            this.tfaDialog = true;
            return;
          }

          this.$router.push(this.$route.query.redirect || "/");
        })
        .catch(() => {
          this.error = true;
          this.loading = false;
          this.pass = "";
        });
    },
    checkrepeat() {
      if (this.newpass !== this.repeatpass) {
        this.passError = "Las contraseñas no coinciden";
        return false;
      }
      this.passError = null;
      return true;
    },
  },
};
</script>

<style>
.logo {
  max-width: 450px;
  margin: auto;
}
</style>
